"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ppg = exports.gyro = exports.accel = exports.telemetry = exports.eegFilter = exports.eeg = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const c = __importStar(require("../lib/constants"));
const epoch_1 = require("./epoch");
const zip_samples_1 = require("./zip-samples");
const nexus_parsers_1 = require("../lib/nexus-parsers");
const eegChannels = c.INSAI_EEG_CHANNELS;
const eegSamplingRate = c.INSAI_EEG_SAMPLING_RATE;
function eeg(emitter) {
    // @ts-ignore
    const $eeg = zip_samples_1.zipSamples(rxjs_1.fromEvent(emitter, 'eeg'), eegChannels, eegSamplingRate)
        .pipe(epoch_1.epochM({
        duration: eegSamplingRate,
        interval: eegSamplingRate,
        channelNames: eegChannels,
        samplingRate: eegSamplingRate,
        packetThreshold: 10,
    }))
        .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
    $eeg.connect();
    return $eeg;
}
exports.eeg = eeg;
function eegFilter(eeg) {
    return eeg.pipe(epoch_1.filterStreams({ nbChannels: eegChannels.length, samplingRate: eegSamplingRate, cutoffFrequencies: [1, 45] }));
}
exports.eegFilter = eegFilter;
function telemetry(emitter) {
    const misc = rxjs_1.fromEvent(emitter, 'misc');
    const $tele = misc.pipe(operators_1.map(nexus_parsers_1.parseTelemetry)).pipe(operators_1.multicast(() => new rxjs_1.Subject()));
    $tele.connect();
    return $tele;
}
exports.telemetry = telemetry;
const motionChannels = c.INSAI_MOTION_CHANNELS;
const motionSamplingRate = c.INSAI_MOTION_SAMPLING_RATE;
function accel(emitter) {
    const $accel = zip_samples_1.zipSamples(rxjs_1.fromEvent(emitter, 'accel'), motionChannels, motionSamplingRate)
        .pipe(epoch_1.epochM({
        duration: motionSamplingRate,
        interval: motionSamplingRate,
        channelNames: motionChannels,
        samplingRate: motionSamplingRate,
        packetThreshold: 5,
    }))
        .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
    $accel.connect();
    return $accel;
}
exports.accel = accel;
function gyro(emitter) {
    const $gyro = zip_samples_1.zipSamples(rxjs_1.fromEvent(emitter, 'gyro'), motionChannels, motionSamplingRate)
        .pipe(epoch_1.epochM({
        duration: motionSamplingRate,
        interval: motionSamplingRate,
        channelNames: motionChannels,
        samplingRate: motionSamplingRate,
        packetThreshold: 5,
    }))
        .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
    $gyro.connect();
    return $gyro;
}
exports.gyro = gyro;
function ppg(emitter) {
    const $ppg = zip_samples_1.zipSamples(rxjs_1.fromEvent(emitter, 'ppg'), motionChannels, motionSamplingRate)
        .pipe(epoch_1.epochM({
        duration: motionSamplingRate,
        interval: motionSamplingRate,
        channelNames: c.INSAI_PPG_CHANNELS,
        samplingRate: motionSamplingRate,
        packetThreshold: 5,
    }))
        .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
    $ppg.connect();
    return $ppg;
}
exports.ppg = ppg;
//# sourceMappingURL=nexus.js.map